import React from 'react';

// VamosMap Context
export const VamosMapContext = React.createContext();
